import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LoginForm } from '../components/auth/LoginForm';
import { Seo } from '../components/Seo';

export const Login: React.FC = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  // Already signed in? Skip the login form and go straight to the dashboard.
  useEffect(() => {
    if (!loading && user) {
      navigate('/dashboard', { replace: true });
    }
  }, [user, loading, navigate]);

  if (!loading && user) {
    return null;
  }

  return (
    <>
      <Seo title="Sign In — Local Area Cloud" description="Sign in to your Local Area Cloud account." path="/login" noindex />
      <LoginForm />
    </>
  );
};
